// extracted by mini-css-extract-plugin
export default {"cardsHeader":"CardsHeader_cardsHeader__yrf98","settingsWrapper":"CardsHeader_settingsWrapper__aiAvt"};